import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17.375 11.3994C19.9984 11.3994 22.125 13.5261 22.125 16.1494C22.125 18.1504 20.9851 19.823 19.9902 20.917C19.4792 21.4789 18.9707 21.9275 18.5908 22.2354C18.2029 22.5497 17.79 22.8236 17.375 23.1006C16.96 22.8236 16.5471 22.5497 16.1592 22.2354C15.7793 21.9275 15.2708 21.4789 14.7598 20.917C13.7649 19.823 12.625 18.1504 12.625 16.1494C12.625 13.5261 14.7516 11.3994 17.375 11.3994ZM20.875 10.9707C19.8764 10.2945 18.6719 9.89941 17.375 9.89941C13.9232 9.89941 11.125 12.6976 11.125 16.1494C11.125 18.6929 12.5478 20.7072 13.626 21.8994H1.875V0.899414H20.875V10.9707ZM16.125 17.3994H18.625V15.3994H16.125V17.3994ZM6.375 12.3994H10.375V10.3994H6.375V12.3994ZM6.375 8.39941H16.375V6.39941H6.375V8.39941Z"}}]};

const DocumentLocationFilled = Vue.extend<IconProps>({
  name: 'DocumentLocationFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'document-location-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default DocumentLocationFilled;
